import { useQuery } from "@apollo/client";
import { CaretDownIcon } from "@phosphor-icons/react";
import { Select } from "antd";
import { get } from "lodash";
import Label from "shared/components/Label";

const { Option } = Select;

const Component = ({
  defaultValue,
  onChange = () => {},
  onSearch = () => {},
  onSelet = () => {},
  format = () => {},
  placeholder = "",
  node,
  label,
  icon,
  ...rest
}) => {
  const [query, options, accessor] = node;
  const { data, loading } = useQuery(query, options);
  const items = get(data, accessor, []);
  return (
    <div className="main__select">
      {label && <Label label={label} icon={icon} />}
      <Select
        loading={loading}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={onChange}
        onSelect={(id) => onSelet(items.find((item) => item.id === id))}
        showArrow={true}
        suffixIcon={<CaretDownIcon size={16} />}
        className="select-async"
        showSearch
        onSearch={onSearch}
        {...rest}
      >
        {items.map((item) => {
          return (
            <Option value={item.id} key={item.id}>
              {format(item)}
            </Option>
          );
        })}
      </Select>
    </div>
  );
};

export default Component;
